const filters = {
  ticket: [
    {
      type: 'input',
      label: 'Ärendenummer',
      key: 'reference'
    },
    {
      type: 'select',
      label: 'Status',
      key: 'status',
      values: [
        {
          label: 'Pågående',
          value: 'OPEN'
        },
        {
          label: 'Löst',
          value: 'RESOLVED'
        },
        {
          label: 'Ny',
          value: 'NEW'
        }
      ]
    },
    {
      type: 'select',
      label: 'Ärendetyp',
      key: 'type',
      values: [
        {
          value: 'QUESTION',
          label: 'Fråga'
        },
        {
          value: 'REPORT',
          label: 'Felanmälan'
        }
      ]
    }
  ],
  invoice: [
    {
      type: 'input',
      label: 'Referens',
      key: 'reference'
    },
    {
      type: 'daterange',
      label: 'Period',
      key: 'period'
    },
    {
      type: 'select',
      label: 'Status',
      key: 'status',
      values: [
        {
          label: 'Redigeras',
          value: 'EDIT'
        },
        {
          label: 'Attestering',
          value: 'REVIEW'
        },
        {
          label: 'Redo att skickas',
          value: 'READY'
        },
        {
          label: 'Inväntar betalning',
          value: 'PENDING_PAYMENT'
        },
        {
          label: 'Betald',
          value: 'PAYED'
        },
        {
          label: 'Delbetald',
          value: 'PARTIALLY_PAYED'
        },
        {
          label: 'Förfallen',
          value: 'OVERDUE'
        },
        {
          label: 'Makulerad',
          value: 'CANCELLED'
        },
        {
          label: 'Krediterad',
          value: 'CREDITED'
        }
      ]
    }
  ],
  maintenance: [
    {
      type: 'input',
      label: 'Aktivitet',
      key: 'title'
    },
    {
      type: 'select',
      label: 'Status',
      key: 'status',
      values: [
        {
          label: 'Pågår',
          value: 'IN_PROGRESS'
        },
        {
          label: 'Klar',
          value: 'DONE'
        },
        {
          label: 'Förfallen',
          value: 'OVERDUE'
        },
        {
          label: 'Makulerad',
          value: 'CANCELLED'
        },
        {
          label: 'Planerad',
          value: 'PLANNED'
        }
      ]
    }
  ],
  tenant: [
    {
      type: 'input',
      label: 'Namn',
      key: 'name'
    },
    {
      type: 'input',
      label: 'Pers/Org-nummer',
      key: 'identifier'
    },
    {
      type: 'input',
      label: 'Telefonnummer',
      input_type: 'number',
      key: 'phone'
    },
    {
      type: 'input',
      label: 'E-Post',
      input_type: 'email',
      key: 'email'
    },
    {
      type: 'select',
      label: 'Status',
      key: 'status',
      values: [
        {
          label: 'Aktiva',
          value: 'ACTIVE'
        },
        {
          label: 'Inaktiva',
          value: 'INACTIVE'
        },
      ]
    }
  ],
  entity: [
    {
      type: 'input',
      label: 'Namn',
      key: 'name'
    },
    {
      type: 'select',
      label: 'Vakant',
      key: 'vacant',
      values: [
        {
          label: 'Ja',
          value: true
        },
      ]
    }
  ],
}
export { filters }
